import React from 'react';

const SvgDownload = props => (
  <svg width={17} height={16} {...props}>
    <path
      d="M16.513 8.07c.27 0 .487.217.487.48v4.35c0 1.708-1.414 3.1-3.157 3.1H3.157C1.417 16 0 14.611 0 12.9V8.478A.48.48 0 0 1 .487 8a.48.48 0 0 1 .487.478V12.9c0 1.18.978 2.143 2.183 2.143h10.686c1.202 0 2.183-.96 2.183-2.143V8.55a.48.48 0 0 1 .487-.48zm-8.346 3.786L5.14 8.77a.492.492 0 0 1 0-.687.467.467 0 0 1 .673 0l2.213 2.26V.485c0-.27.211-.486.476-.486.264 0 .475.216.475.486v9.855l2.21-2.26a.467.467 0 0 1 .673 0 .492.492 0 0 1 0 .688l-3.023 3.087a.46.46 0 0 1-.67 0z"
      fill="#046FE2"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgDownload;
